module.exports = __webpack_public_path__ + "static/icons/icon-caret-down--grey-47055d36f5a02cfdbdb5a6a793d26fab.svg";